"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.object.create");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthorizationCodeCallback = exports.RequestAuthorizationCode = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactOauthFlow = require("react-oauth-flow");

var _pkce = require("./pkce");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var BaseOAuthClientComponent = /*#__PURE__*/function (_Component) {
  _inherits(BaseOAuthClientComponent, _Component);

  var _super = _createSuper(BaseOAuthClientComponent);

  function BaseOAuthClientComponent() {
    _classCallCheck(this, BaseOAuthClientComponent);

    return _super.apply(this, arguments);
  }

  return BaseOAuthClientComponent;
}(_react.Component);

var basePropTypes = {
  oauthClient: _propTypes["default"].shape({
    options: _propTypes["default"].shape({
      clientId: _propTypes["default"].string.isRequired,
      clientSecret: _propTypes["default"].string.isRequired,
      redirectUri: _propTypes["default"].string.isRequired,
      authorizationUri: _propTypes["default"].string.isRequired,
      accessTokenUri: _propTypes["default"].string.isRequired
    }),
    code: _propTypes["default"].shape({
      getToken: _propTypes["default"].func.isRequired
    })
  })
};
BaseOAuthClientComponent.propTypes = basePropTypes;

var RequestAuthorizationCode = /*#__PURE__*/function (_BaseOAuthClientCompo) {
  _inherits(RequestAuthorizationCode, _BaseOAuthClientCompo);

  var _super2 = _createSuper(RequestAuthorizationCode);

  function RequestAuthorizationCode(props) {
    var _this;

    _classCallCheck(this, RequestAuthorizationCode);

    _this = _super2.call(this, props);
    _this.state = {
      // generate code challenge for PKCE
      code_challenge: (0, _pkce.generateCodeChallenge)()
    };
    return _this;
  }

  _createClass(RequestAuthorizationCode, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          oauthClient = _this$props.oauthClient,
          _this$props$args = _this$props.args,
          args = _this$props$args === void 0 ? {} : _this$props$args,
          props = _objectWithoutProperties(_this$props, ["oauthClient", "args"]); // obtain required options for OauthSender


      var options = _objectSpread(_objectSpread({}, props), {}, {
        // use oauth client's options if available
        clientId: oauthClient.options.clientId,
        authorizeUrl: oauthClient.options.authorizationUri,
        redirectUri: oauthClient.options.redirectUri,
        args: _objectSpread({
          // add PKCE params to existing args
          code_challenge: this.state.code_challenge,
          code_challenge_method: "S256"
        }, args)
      });

      return /*#__PURE__*/_react["default"].createElement(_reactOauthFlow.OauthSender, options);
    }
  }]);

  return RequestAuthorizationCode;
}(BaseOAuthClientComponent);

exports.RequestAuthorizationCode = RequestAuthorizationCode;
delete _reactOauthFlow.OauthSender.propTypes.authorizeUrl;
delete _reactOauthFlow.OauthSender.propTypes.clientId;
delete _reactOauthFlow.OauthSender.propTypes.redirectUri;
RequestAuthorizationCode.propTypes = _objectSpread(_objectSpread({}, basePropTypes), _reactOauthFlow.OauthSender.propTypes);
RequestAuthorizationCode.defaultProps = _objectSpread({}, _reactOauthFlow.OauthSender.defaultProps);

var AuthorizationCodeCallback = /*#__PURE__*/function (_BaseOAuthClientCompo2) {
  _inherits(AuthorizationCodeCallback, _BaseOAuthClientCompo2);

  var _super3 = _createSuper(AuthorizationCodeCallback);

  function AuthorizationCodeCallback() {
    _classCallCheck(this, AuthorizationCodeCallback);

    return _super3.apply(this, arguments);
  }

  _createClass(AuthorizationCodeCallback, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          oauthClient = _this$props2.oauthClient,
          props = _objectWithoutProperties(_this$props2, ["oauthClient"]); // obtain required options for OauthReceiver


      var options = _objectSpread(_objectSpread({}, props), {}, {
        // use oauth client's options if available
        clientId: oauthClient.options.clientId,
        clientSecret: oauthClient.options.clientSecret,
        tokenUrl: oauthClient.options.accessTokenUri,
        redirectUri: oauthClient.options.redirectUri,
        tokenFn: props.tokenFn || function () {
          // Obtain the generated and stored code verifier for PKCE
          var codeVerifier = (0, _pkce.getCodeVerifier)();
          return oauthClient.code.getToken(document.location.href, {
            body: {
              code_verifier: codeVerifier
            }
          }).then(function (token) {
            // react-oauth-flow expects the `access_token` attribute to exist
            token.access_token = token;
            return token;
          });
        }
      });

      return /*#__PURE__*/_react["default"].createElement(_reactOauthFlow.OauthReceiver, options);
    }
  }]);

  return AuthorizationCodeCallback;
}(BaseOAuthClientComponent);

exports.AuthorizationCodeCallback = AuthorizationCodeCallback;
delete _reactOauthFlow.OauthReceiver.propTypes.tokenUrl;
delete _reactOauthFlow.OauthReceiver.propTypes.redirectUri;
delete _reactOauthFlow.OauthReceiver.propTypes.clientId;
delete _reactOauthFlow.OauthReceiver.propTypes.clientSecret;
AuthorizationCodeCallback.propTypes = _objectSpread(_objectSpread({}, basePropTypes), _reactOauthFlow.OauthReceiver.propTypes);
AuthorizationCodeCallback.defaultProps = _objectSpread({}, _reactOauthFlow.OauthReceiver.defaultProps);